<template>
  <div class="container">
    <div class="page-header-content pb-3 mb-1">
      <div class="row align-items-center justify-content-between">
        <div class="col-md-12 mt-4">
          <h1 class="checkout-title text-center" style="font-size: 3rem;">
            Gestisci le risposte al tuo test pubblicato
          </h1>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Card dati test -->
      <div class="col-md-4">
        <div class="card card-primary">
          <div class="card-header">Dati del test pubblicato</div>
          <div class="card-body">
            <ul class="list-group list-group-flush" v-if="tests.length > 0">
              <li class="list-group-item px-0">
                <strong>Domanda test: </strong> {{ tests[0].testRequest?.request }}
              </li>
              <li class="list-group-item px-0">
                <strong>Creato il: </strong> {{ tests[0].testRequest?.created_at }}
              </li>
              <li class="list-group-item px-0">
                <strong>Nome del test: </strong> {{ tests[0].activity_name }}
              </li>
              <li class="list-group-item px-0" v-for="(response, index) in filteredResponses" :key="index">
                <strong>Opzione risposta: </strong> {{ response }}
              </li>

              <li class="list-group-item px-0"
                v-if="filteredResponses['response_' + tests[0].testRequest?.correct_response]">
              </li>
              <strong>Risposta corretta :</strong> {{ filteredResponses['response_' +
                tests[0].testRequest?.correct_response] }}

            </ul>
          </div>
        </div>
      </div>

      <!-- Card risposte utenti -->
      <div class="col-md-8">
        <div class="card card-primary">
          <div class="card-header">Risposte degli utenti</div>
          <div class="card-body">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Utente</th>
                  <th>Risposta</th>
                  <th>Voto</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="test in tests" :key="test.id">
                  <td>{{ test.full_name }}</td>
                  <td>{{ test.response }}</td>
                  <td>{{ test.vote }}</td>
                  <td>
                    <div v-if="test.vote == null || test.note == null">
                      <button type="button" class="btn btn-dark btn-icon" @click="openNote(test)">
                        <i class="las la-pen-fancy"></i>
                      </button>
                    </div>
                    <div v-else>
                      <button type="button" class="btn btn-dark btn-icon" disabled>
                        <i class="las la-pen-fancy"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


    </div>

    <!-- Modal -->
    <div class="modal fade" id="modal-note-form" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Dai un voto e inserisci una nota
            </h5>
            <button type="button" class="close" data-dismiss="modal" id="close-form-note" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent="saveNote">
            <div class="modal-body p-4">
              <div v-if="formApp.vote == null">
                <fieldset class="form-group">
                  <div class="row">
                    <legend class="col-form-label col-sm-2 pt-0">Voto:</legend>
                    <div class="col-sm-10">
                      <div class="form-check form-check-inline" v-for="(index, number) in votes" :key="index">
                        <input class="form-check-input" type="radio" :id="'gridRadios-' + number"
                          v-model="formVote.vote" :value="index" />
                        <label class="form-check-label" :for="'gridRadios-' + number">&nbsp;{{ index }}</label>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div v-else>Voto assegnato: {{ formApp.vote }}</div>

              <div class="form-group" v-if="formApp.note == null">
                <label for="note">Scrivi qui la tua nota</label>
                <textarea class="form-control" id="note" rows="3" v-model="formVote.note"></textarea>
              </div>
              <div v-else>Note: {{ formVote.note }}</div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Chiudi
              </button>
              <div v-if="formApp.note == null || formApp.vote == null">
                <button type="submit" class="btn btn-primary">Salva</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

export default {
  name: "TestPage",
  props: ["id"],
  data() {
    return {
      tests: [],
      votes: [1, 2, 3, 4, 5],
      loading: true,
      formApp: {},
      errors: [],
      formVote: {
        id: 0,
        note: null,
        vote: null,
      },
    };
  },
  computed: {
    filteredResponses() {
      if (!this.tests.length || !this.tests[0].testRequest) return [];

      const responses = this.tests[0].testRequest.responses;

      // Controlla che sia un oggetto
      if (!responses || typeof responses !== "object") return [];

      // Trasforma l'oggetto in array di valori e filtra
      return Object.values(responses).filter(r => r !== null && r !== "");
    }
  },
  mounted() {
    this.loadResponses();
  },
  methods: {
    async loadResponses() {
      try
      {
        const response = await httpauth.get("/test-responses/show/" + this.id);
        this.tests = response.data.data || [];
      } catch (error)
      {
        if (error.response?.status === 401 && error.response.data.message === "Unauthenticated.")
        {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        }
      }
    },
    openNote(test) {
      this.formApp = test;
      this.formVote.id = test.id;
      this.formVote.vote = test.vote;
      this.formVote.note = test.note;
      $("#modal-note-form").modal("show");
    },
    async saveNote() {
      const $toast = useToast();
      try
      {
        const response = await httpauth.post("/test-response/vote-note-response", this.formVote);
        document.getElementById("close-form-note").click();

        if (response.data.status)
        {
          this.formVote = { id: 0, note: null, vote: null };
          $toast.open({ message: response.data.message, type: "info", position: "top-right" });
        } else
        {
          $toast.open({ message: response.data.message, type: "danger", position: "top-right" });
          this.loadResponses();
        }
      } catch (error)
      {
        if (error.response?.status === 401 && error.response.data.message === "Unauthenticated.")
        {
          const auth = useAuth();
          auth.clearToken();
          window.location.href = "/";
        } else if (error.response?.status === 404)
        {
          $toast.open({ message: error.response.data.message, type: "danger", position: "top-right" });
          window.location.href = "/";
        } else if (error.response?.data?.errors)
        {
          this.errors = error.response.data.errors;
        }
      }
    },
  },
};
</script>

<style scoped>
/* Add your own custom styles here */

/* Optional: Style the entire page or container */
/* Add your own custom styles here */

/* Optional: Style the entire page or container */
.container {
  padding: 20px;
}

/* Style the Bootstrap table */
.table-hover {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

/* Table header styles */
.table-hover th {
  background-color: #f8f9fa;
  color: #212529;
  font-weight: bold;
  padding: 10px;
  text-align: left;
  border-bottom: 2px solid #dee2e6;
}

/* Table row styles */
.table-hover tr {
  transition: background-color 0.2s ease;
}

/* Alternate row background colors */
.table-hover tr:nth-child(even) {
  background-color: #f2f2f2;
}

/* Hover effect */
.table-hover tbody tr:hover {
  background-color: #e2e6ea;
}

/* Table cell styles */
.table-hover td {
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
}

/* Last cell in each row */
.table-hover td:last-child {
  text-align: center;
}

.btn-icon {
  padding-left: 4px;
  padding-right: 4px;
  width: auto;
  /* per evitare che Bootstrap lo allarghi */
}
</style>